<template>
    <div>
        <Table ref="mt" :columns="columns" :data="page.list" :loading="loading" :height="mtHeight">
            <template slot-scope="{ row, column }"
                    slot="anchor">
                    <div v-if="row[column.key]" class="error-number" @click="showInfoList(row, column)">{{row[column.key]}}</div>
                    <div v-else>0</div>
                </template>
        </Table>
        <smart-modal
            v-model="modal.showInfoList"
            :title="dataSource + '明细'"
            :width="800"
            :height="650"
            :maskClosable="false"
            :buttons="buttons"
        >
            <order-info v-if="modal.showInfoList" :filter="modalFilter"></order-info>
        </smart-modal>
    </div>
</template>
<script>
import { mapCell, pipeCell } from '_c/grid/renderCell'
import { statisticOrderMonitor } from '@/api/order-manage'
import OrderInfo from "./order-info"
import Dict from '_u/dict'
export default {
    name: 'ListStatisticOrderMonitor',

    components: { OrderInfo },

    props: {
        date: Object
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            filter: {
                orderDataSource: this.$cache.orderDataSource
            },
            page: {
                list: []
            },
            dict: {
                serviceType: Dict.NULL,
                orderStatus: Dict.NULL
            },
            modal: {
                showInfoList: false
            },
            curId: '',
            modalFilter: {},
            buttons: [
                {
                    type: 'default',
                    text: '关闭'
                }
            ]
        }
    },

    computed: {
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    minWidth: 60
                },
                {
                    key: 'serviceType',
                    title: '服务类别',
                    align: 'center',
                    minWidth: 100,
                    render: mapCell(this.dict.serviceType.val())
                },
                {
                    key: 'delayIng',
                    title: `超时(执行中)`,
                    align: 'center',
                    minWidth: 100,
                    slot: "anchor"
                },
                {
                    key: 'delayDone',
                    title: `超时(已归档)`,
                    align: 'center',
                    minWidth: 100,
                    slot: "anchor"
                },
                {
                    key: 'repulseIng',
                    title: `异常(执行中)`,
                    align: 'center',
                    minWidth: 100,
                    slot: "anchor"
                },
                {
                    key: 'repulseDone',
                    title: `异常(已归档)`,
                    align: 'center',
                    minWidth: 100,
                    slot: "anchor"
                },
                {
                    key: 'bad',
                    title: `差评(已归档)`,
                    align: 'center',
                    minWidth: 100,
                    slot: "anchor"
                }
            ]
        },
        dataSource() {
            return this.filter.orderDataSource == 'G' ? '工单' : '任务'
        },
        serviceTypeKeys() {
            return this.dict.serviceType.val().map(el => el.id).filter(el=> el)
        }
    },

    watch: {
        date: {
            handler(val) {
                this.fetch()
            },
            deep: true
        }
    },

    created() {
        this.fetch()
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                40
        })
    },

    methods: {
        fetch() {
            this.loading = true
            let date = Object.assign({}, this.date)
            let body = Object.assign(date, this.filter)
            Promise.all([
                Dict.get(['service_type', 'order_status']),
                statisticOrderMonitor(body)
            ])
                .then(args => {
                    var [dictGroup, page] = args
                    Object.keys(this.dict).forEach(name => {
                        this.dict[name] = dictGroup[name]
                    })

                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        setPageData(data) {
            if (data.list) {
                var group = data.list.groupBy('serviceType')
                var list = [],
                    totalRow = {
                        delayIng: 0,
                        delayDone: 0,
                        repulseIng: 0,
                        repulseDone: 0,
                        bad: 0,
                        total: 0
                    }
                this.serviceTypeKeys.forEach(key => {
                    let row = {}
                    if (group[key]) {
                        row = Object.assign({}, group[key][0])
                        // 合计列
                        row.total =
                            parseInt(row.delayIng || 0) +
                            parseInt(row.delayDone || 0) +
                            parseInt(row.bad || 0) +
                            parseInt(row.repulseIng || 0) +
                            parseInt(row.repulseDone || 0)
                        Object.keys(totalRow).forEach(key => {
                            // 合计行
                            totalRow[key] += parseInt(row[key] || 0)
                        })
                    } else {
                        row = {
                            serviceType: key,
                            delayIng: 0,
                            delayDone: 0,
                            repulseIng: 0,
                            repulseDone: 0,
                            bad: 0,
                            total: 0
                        }
                    }
                    list.push(row)
                })
                totalRow.serviceType = '合计'
                list.push(totalRow)
                this.page.list = list
            }
        },
        total(obj, status) {
            var data = obj.find(v => v.orderStatus == status),
                total = data ? data.total : 0
            return parseInt(total)
        },
        showInfoList(row, column) {
            let body = Object.assign({}, this.date)
            Object.assign(body, this.filter)
            Object.assign(body, {
                serviceType: row.serviceType == "合计"? "" : row.serviceType,
                queryType: column.key
            })
            this.modalFilter = body
            this.modal.showInfoList = true
        }
    }
}
</script>
<style lang="less" 
    scoped>
    .error-number {
        color: @error-color;
        cursor: pointer;
    }
</style>